import { render, staticRenderFns } from "./VideoLibrary.vue?vue&type=template&id=54dd8a64"
import script from "./VideoLibrary.vue?vue&type=script&lang=js"
export * from "./VideoLibrary.vue?vue&type=script&lang=js"
import style0 from "./VideoLibrary.vue?vue&type=style&index=0&id=54dd8a64&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54dd8a64')) {
      api.createRecord('54dd8a64', component.options)
    } else {
      api.reload('54dd8a64', component.options)
    }
    module.hot.accept("./VideoLibrary.vue?vue&type=template&id=54dd8a64", function () {
      api.rerender('54dd8a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/VideoLibrary.vue"
export default component.exports